module.exports = __webpack_public_path__ + "img/failstrong.a179f328.svg";